import {
  Button,
  IconText,
  Image,
} from "@wac-ui-dashboard/wac_component_library";
import useUploadImageProof from "./useUploadImageProof";

const UploadImageProof = ({
  spinWheelRewardsState,
  setSpinWheelRewardsState,
  refetch,
}) => {
  const { formik, handleCloseModal } = useUploadImageProof({
    spinWheelRewardsState,
    setSpinWheelRewardsState,
    refetch,
  });

  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="image"
          className="pro-font-sm pro-mb-1 pro-fw-medium pro-d-flex pro-align-center"
        >
          Proof of Redemption (Photo)
          <span
            className="pro-ms-2 pro-tooltip"
            title="Attach an image as proof to mark this reward as redeemed"
          >
            <span
              className="material-symbols-outlined"
              style={{
                color: "#f39c12",
                fontSize: "18px",
                cursor: "pointer",
                verticalAlign: "middle",
              }}
            >
              error
            </span>
          </span>
        </label>

        <div className="input-drag">
          <input
            type="file"
            accept=".jpeg,.jpg,.png"
            className={`pro-input ${
              formik.errors.image && formik.touched.image ? "error" : ""
            }`}
            id="image"
            onBlur={formik.handleBlur("image")}
            onChange={(e) =>
              formik.setFieldValue("image", e?.target?.files[0] ?? "")
            }
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.image !== ""
                  ? formik?.values.image?.name
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {formik.touched.image && formik.errors.image && (
            <span className="error-text">{formik.errors.image}</span>
          )}
        </div>

        {formik?.values?.image && (
          <div className="col-2 pro-my-2">
            <Image
              width={100}
              height={100}
              src={
                formik?.values?.image instanceof File
                  ? URL.createObjectURL(formik?.values?.image)
                  : formik?.values?.image
              }
              alt="proof image"
            />
          </div>
        )}
      </div>

      <div className="col-12 pro-d-flex pro-justify-end">
        <Button
          className="pro-btn-link lg pro-px-5"
          onClick={() => handleCloseModal()}
        >
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading" : ""
          }`}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default UploadImageProof;
